<template>
    <div class="flex flex-col mt-5">
        <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
            <div
                class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
            >
                <table class="min-w-full divide-y divide-gray-200">
                    <thead>
                        <tr>
                            <th
                                class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                            >
                                {{ $tc('messages.grades', 1) }}
                            </th>
                            <th
                                class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                            >
                                {{ $t('messages.points') }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="bg-gray-50">
                            <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">0</td>
                            <td
                                class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500 flex gap-x-2 justify-around"
                            >
                                <div>
                                    <BadgePill color="green">
                                        {{ 0 }}
                                    </BadgePill>
                                </div>
                                <div>
                                    <BadgePill color="yellow">
                                        {{ 0 }}
                                    </BadgePill>
                                </div>
                            </td>
                        </tr>
                        <tr
                            :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                            v-for="(range, index) in rangesTable"
                            :key="range.ordinal"
                        >
                            <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                <span :title="range.text">{{ range.letters }}</span>
                            </td>
                            <td
                                class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500 flex gap-x-2 justify-around"
                            >
                                <div>
                                    <BadgePill color="green" v-if="range.points">
                                        {{ range.points }}
                                    </BadgePill>
                                </div>
                                <div>
                                    <BadgePill color="yellow" v-if="range.coins_points">
                                        {{ range.coins_points }}
                                    </BadgePill>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="mt-1">
        <FormLabel :value="$t('messages.score_weight')" for="weight" />
        <FormSelect required id="weight" v-model="weight" :options="weights" :null-option="false" class="mt-1 w-full" />
    </div>
</template>

<script>
export default {
    name: 'GamificationActivityPointsPreview',
};
</script>
<script setup>
import { computed, ref } from 'vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import BadgePill from '@/components/BadgePill.vue';

const props = defineProps({
    ranges: {
        type: Array,
        required: true,
    },
    weights: {
        type: Array,
        required: true,
    },
    settings: {
        type: Object,
        required: false,
    },
});

const weight = ref(2);

const rangesCount = props.ranges.length;

const rangesTable = computed(() => {
    return props.ranges.map((r) => {
        let points = null;
        if (props.settings.is_experience_for_activity_active) {
            if (props.settings.is_experience_for_activity_reward_proportional) {
                points = Math.floor((weight.value / 2) * props.settings.base * r.ordinal * (1 / rangesCount));
            } else {
                points = Math.floor((weight.value / 2) * props.settings.base);
            }
        }
        let coinsPoints = null;
        if (props.settings.is_coins_for_activity_active) {
            if (props.settings.is_coins_for_activity_reward_proportional) {
                coinsPoints = Math.floor(
                    (weight.value / 2) * props.settings.coins_amount_base * r.ordinal * (1 / rangesCount),
                );
            } else {
                coinsPoints = Math.floor((weight.value / 2) * props.settings.coins_amount_base);
            }
        }

        return {
            points: points,
            coins_points: coinsPoints,
            ordinal: r.ordinal,
            text: r.text,
            letters: r.letters,
        };
    });
});
</script>
